// A simple transformation that makes object to start with lowercase
// Note that this is not full implementation as it supports only:
// undefined, null, arrays, number, string, bool. Anything out of this
// list is considered Object
export default function transformACSLayout(something: { [key: string]: any }): { [key: string]: any } {
    if (!something) {
        return something;
    }

    if (Array.isArray(something)) {
        return something.map((item) => {
            return transformACSLayout(item);
        });
    }

    if (typeof something === "string" || typeof something === "number" || typeof something === "boolean") {
        return something;
    }

    const initial: { [key: string]: any } = {};
    return Object.keys(something).reduce((accumulator, current) => {
        const value = something[current];
        const convertedValue = transformACSLayout(value);

        let key = current;
        if (current[0]?.toLowerCase() !== current[0]) {
            key = current[0].toLowerCase() + current.substr(1);
        }

        accumulator[key] = convertedValue;
        return accumulator;
    }, initial);
}
